import React from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../components/components"
import { getLaenderCodes } from "../constants"
import { useChangeProperty } from "./hooks/UseChangeProperty"
import { useStoreRechnung } from "../store"

interface SteuervertreterVerkaeufersViewProps {
    basePath: string
}

export function SteuervertreterVerkaeufersView({ basePath }: SteuervertreterVerkaeufersViewProps) {
    const { t } = useTranslation()
    const { steuervertreter } = useStoreRechnung("steuervertreter")
    const [onChange] = useChangeProperty(basePath)
    const laenderOptions = getLaenderCodes()

    return (
        <Components.Collapsible title={t("rechnung.steuervertreter.title")} collapsed={true}>
            <Components.FormGroup label={t("rechnung.steuervertreter.name.label")}>
                <Components.TextEdit placeholder={t("rechnung.steuervertreter.name.placeholder")} onChange={onChange("name")} value={steuervertreter.name} />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuervertreter.umsatzsteuerId.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.steuervertreter.umsatzsteuerId.placeholder")}
                    onChange={onChange("umsatzsteuerId")}
                    value={steuervertreter.umsatzsteuerId}
                />
            </Components.FormGroup>

            <Components.Collapsible title={t("rechnung.steuervertreter.anschrift.title")} collapsed={false}>
                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.strasse1.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.strasse1.placeholder")}
                        onChange={onChange("anschrift.strasse1")}
                        value={steuervertreter.anschrift?.strasse1}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.strasse2.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.strasse2.placeholder")}
                        onChange={onChange("anschrift.strasse2")}
                        value={steuervertreter.anschrift?.strasse2}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.strasse3.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.strasse3.placeholder")}
                        onChange={onChange("anschrift.strasse3")}
                        value={steuervertreter.anschrift?.strasse3}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.ort.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.ort.placeholder")}
                        onChange={onChange("anschrift.ort")}
                        value={steuervertreter.anschrift?.ort}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.plz.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.plz.placeholder")}
                        onChange={onChange("anschrift.plz")}
                        value={steuervertreter.anschrift?.plz}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.bundesland.label")}>
                    <Components.TextEdit
                        placeholder={t("rechnung.steuervertreter.anschrift.bundesland.placeholder")}
                        onChange={onChange("anschrift.bundesland")}
                        value={steuervertreter.anschrift?.bundesland}
                    />
                </Components.FormGroup>

                <Components.FormGroup label={t("rechnung.steuervertreter.anschrift.land.label")}>
                    <Components.MultiSelect
                        placeholder={t("rechnung.steuervertreter.anschrift.land.placeholder")}
                        onChange={onChange("anschrift.land")}
                        value={laenderOptions.find((o) => o.value === steuervertreter.anschrift?.land)}
                        options={laenderOptions}
                        isClearable={true}
                    />
                </Components.FormGroup>
            </Components.Collapsible>
        </Components.Collapsible>
    )
}
